import React from "react";
import { Typography, Box } from "@mui/material";
import CategoryList from "./CategoryList";

export default function CategoryGroup({
	categoriesType,
	data,
	openDeleteGroupModal,
}) {
	const boxStyles = {
		borderRadius: "20px",
		flex: 1,
		minWidth: 300,
	};

	const innerBoxStyles = {
		display: "flex",
		flexWrap: "wrap",
		alignItems: "flex-start",
	};
	return (
		<Box sx={boxStyles}>
			<Typography variant="h5" gutterBottom sx={{ textAlign: "center" }}>
				{categoriesType}
			</Typography>
			<Box sx={innerBoxStyles}>
				{data.map((categoryGroup) => (
					<CategoryList
						key={categoryGroup._id}
						categoryGroup={categoryGroup}
						openDeleteModal={openDeleteGroupModal}
					/>
				))}
			</Box>
		</Box>
	);
}
